
import { MapLocation } from '@/types/location';

// Duel Arena Game Center Locations
export const duelArenaGameCenters: MapLocation[] = [
  {
    id: 41001,
    name: "Duel Arena - Riyadh (King Faisal)",
    type: "Game Center",
    devices: 2,
    coordinates: [24.770861555359765, 46.78031286272666],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "10-35",
    orientation: "Portrait",
    segment: "Game"
  }
];
